import { render } from "./ArticleRewrite.vue?vue&type=template&id=505e2f6f&scoped=true"
import script from "./ArticleRewrite.vue?vue&type=script&lang=js"
export * from "./ArticleRewrite.vue?vue&type=script&lang=js"

import "./ArticleRewrite.vue?vue&type=style&index=0&id=505e2f6f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505e2f6f"]])

export default __exports__